
import React, { useEffect, useState,useRef } from "react";
import { Accordion, AccordionSummary, Typography, Box, Grid, Card, Button, Tab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { styles } from "../../styles/styles";
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import PersonalDetailsForm from "../Authentication/PersonalDetailsForm";
import axios from "axios";
import { matrimoneyEndPoints } from "../../../services/apis";

const ViewProfile = (props) => {
  const [profileData, setProfileData] = useState(props.profileData)
  let getMyProfileData = localStorage.getItem("profileData")
  let MyProfileData = JSON.parse(getMyProfileData)
    let apiCall = useRef(false)
  let userType = sessionStorage.getItem("userType")
  const [open, setOpen] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };

  const getCustomerData = async () => {
    try {
      let userType = sessionStorage.getItem("userType")
      let token
      if (userType) {
        token = sessionStorage.getItem("token");
      } else {
        token = localStorage.getItem("token");
      }
      const response = await axios.post(
        matrimoneyEndPoints.VIEW_CUSTOMER_DETAILS,
        { profileId: props?.profileId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        setProfileData(response?.data?.data)
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    }
  };
  // useEffect(() => {
  //   getCustomerData()
  // }, [open])
useEffect(() => {
    if (!apiCall.current) {
      apiCall.current = true
      getCustomerData();
    }
  }, []);
  const [expanded, setExpanded] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  if (!props?.profileData) {
    return <p>No profile data available.</p>;
  }

  const groupData = {
    personalDetails: profileData?.["Profile Details"] || {},
    casteReligion: profileData?.["Religion & Catse Information"] || {},
    contactDetails: profileData?.["Contact Details"] || {},
    applicationInfo: profileData?.["Application Info"] || {},
    lifestyle: profileData?.["Life Style"] || {},
    images: profileData?.["Uploads"] || {},
  };


  // {Object.entries(data)
  //   .filter(([_, value]) => value !== "" && value !== null && value !== undefined)
  //   .map(([key, value], index) => (
  //     <Grid item xs={12} sm={6} key={index} sx={{ padding: "10px" }}>
  //       <Box sx={{ display: "flex", justifyContent: "space-between" }}>
  //         <Typography sx={{ fontWeight: 700, fontSize: '20px' }}>
  //           <strong>{key}</strong>
  //         </Typography>
  //         <Typography sx={{ fontSize: "20px" }}>
  //           {value}
  //         </Typography>
  //       </Box>
  //     </Grid>
  // ))}


  const renderSection = (title, data) => (
    <Card sx={{ padding: "10px 50px", mb: "20px", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", border: "3px solid rgba(0, 0, 0, 0.1)" }}>
      <Typography sx={{ ...styles.viewtextstyle }}>
        {title}
      </Typography>

      {data && Object.keys(data).length > 0 ? (
        <Grid container spacing={2}>
          {Object.entries(data)
            .filter(([_, value]) => value !== "" && value !== null && value !== undefined)
            .map(([key, value], index) => (
              // <Grid item xs={12} sm={6} key={index} sx={{ padding: "10px" }}>
              //   <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              //     <Typography sx={{ fontFamily: '"Roboto Condensed", sans-serif', fontWeight: 700, fontSize: '20px' }}>
              //       <strong>{key}</strong>
              //     </Typography>
              //     {/* <Typography sx={{ fontSize: "20px" }}>
              //       {value}
              //     </Typography> */}
              //      {typeof value === "string" && value.startsWith("http") && (key.toLowerCase().includes("image") || key.toLowerCase().includes("picture")) ? (
              //    <Box
              //    component="img"
              //    src={value}
              //    alt={key}
              //    sx={{
              //      width: '100%',
              //      maxWidth: '100%',
              //      maxHeight: 400,
              //      height: 'auto',
              //      borderRadius: 2,
              //      objectFit: 'contain', // changed from "cover" to "contain"
              //      border: '1px solid #ccc',
              //      backgroundColor: '#f9f9f9', // optional: helps if image doesn't fill full box
              //    }}
              //  />

              //   ) : (
              //     <Typography sx={{ fontSize: "20px" }}>{String(value)}</Typography>
              //   )}
              //   </Box>
              // </Grid>
              <Grid item xs={12} sm={6} key={index} sx={{ padding: "10px", borderBottom: "2px dotted #ccc", }}>
                {typeof value === "string" &&
                  value.startsWith("http") &&
                  (key.toLowerCase().includes("image") || key.toLowerCase().includes("picture")) ? (
                  // Image case — vertical layout
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography
                      sx={{
                        fontFamily: '"Roboto Condensed", sans-serif',
                        fontWeight: 700,
                        fontSize: '20px',
                        textAlign: "start"
                      }}
                    >
                      <strong>{key}</strong>
                    </Typography>
                    <Box
                      component="img"
                      src={value}
                      alt={key}
                      sx={{
                        width: '100%',
                        maxWidth: '100%',
                        maxHeight: 400,
                        height: 'auto',
                        borderRadius: 2,
                        objectFit: 'contain',
                        border: '1px solid #ccc',
                        backgroundColor: '#f9f9f9',
                      }}
                    />
                  </Box>
                ) : (
                  // Non-image case — horizontal layout
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography
                      sx={{
                        fontFamily: '"Roboto Condensed", sans-serif',
                        fontWeight: 700,
                        fontSize: '20px',
                      }}
                    >
                      <strong>{key}</strong>
                    </Typography>
                    <Typography sx={{ fontSize: "20px" }}>{String(value)}</Typography>
                  </Box>
                )}
              </Grid>

            ))}
        </Grid>
      ) : (
        <Typography sx={{ fontSize: "18px", color: "#888", textAlign: "center" }}>
          No Data Available
        </Typography>
      )}
    </Card>
  );


  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: "flex-end", mb: 2 }}>
        {/* <Typography sx={{ fontFamily: '"Roboto Condensed", sans-serif', fontWeight: 600, fontSize: '24px' }}>
          Personal Details
        </Typography> */}
        {((MyProfileData && MyProfileData.id == props?.profileId) || userType) &&
          // <Button variant="contained" onClick={() => setOpen(!open)} sx={{
          //   backgroundColor: '#C1721F', color: 'white', display: 'flex', gap: '5px',
          //   justifyContent:"end",
          //   marginRight: { xs: "40px", sm: "0px" }
          // }}>
          //   {open ? "View" : "Edit"}
          // </Button>
        
  <Button
    variant="contained"
  
    onClick={() => setOpen(!open)}
    sx={{
      backgroundColor: '#C1721F',
      color: 'white',
      display: 'flex',
      gap: '5px',
    }}
  >
    {open ? "View" : "Edit"}
  </Button>
        }
      </Box>
      {!open ? (
        <Card
          sx={{
            ...styles.cardeducation,
            height: { xs: "auto", sm: "auto" },
            padding: { xs: 2, sm: 4 },
            borderRadius: "5px",
          }}
        >
          <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
          <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
          <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
          <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />

          <Box
            sx={{
              width: "100%",
              margin: "auto",
              backgroundColor: "white",
              border: "2px solid #C1721F",
              padding: { xs: "10px", sm: "50px 50px" },
              borderRadius: "10px",
              boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            {renderSection("Personal Details", groupData.personalDetails)}
            {renderSection("Religion & Caste Information", groupData.casteReligion)}
            {renderSection("Contact Details", groupData.contactDetails)}
            {renderSection("Application Info", groupData.applicationInfo)}
            {renderSection("Life Style", groupData.lifestyle)}
            {userType && renderSection("Uploaded Images", groupData.images)}
          </Box>

        </Card>
      ) : (
        <Box sx={{ width: { xs: "390px", sm: "800px", md: "1405px" }, margin: "auto",}}>
          {/* <PersonalDetailsForm type="edit" /> */}
          <PersonalDetailsForm
            type="edit"
            onSubmitSuccess={() => setOpen(false)}
          />        </Box>
      )}
    </Box>
  );
};

export default ViewProfile;

